import RedeApp from './rede/RedeApp';

/**
 * Módulo Rede — porte do sistema web externo (mapa de ativação,
 * ocorrências, rompimentos, estoque e rotas).
 *
 * O backend continua rodando separado; aqui só consumimos a API dele.
 */
export default function Rede() {
  return <RedeApp />;
}
